import { render } from "./non-it-assets.vue?vue&type=template&id=371d99d8"
import script from "./non-it-assets.vue?vue&type=script&lang=js"
export * from "./non-it-assets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__